import {css} from 'lit';

export const resetStyles = css`
.reset, a, form, html, li, ol, ul {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
  font-style: normal;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
}
`;
